import { parsePhoneNumberFromString } from "libphonenumber-js"

const formatPhoneNumber = (phone) => {
  if (!phone) return ""
  const pn = parsePhoneNumberFromString(phone)
  if (pn?.country === "IN") {
    // Indian format: +91 XXXXX XXXXX
    return `+91 ${pn?.nationalNumber?.slice(0, 5)} ${pn?.nationalNumber?.slice(5)}`
  } else if (pn?.country === "US" || pn?.country === "CA") {
    // US/Canada format: +1 (XXX) XXX-XXXX
    return `+${pn?.countryCallingCode} ${pn?.formatNational()}`
  } else {
    // Other countries: international format
    return pn?.formatInternational()
  }
}

const formatCurrency = (amount, locale = "en-US", currency = "USD") => {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount || 0)
}


const capitalizeFirstLetter = (str) => {
  if (!str) return ""
  return str.charAt(0)?.toUpperCase() + str.slice(1)
}

export { formatPhoneNumber, formatCurrency, capitalizeFirstLetter }
